import React from 'react';
import { UseFormMethods } from 'react-hook-form';
// import { useDispatch } from 'react-redux';
// import DialogList from 'src/dialogs';
// import Button from '../forms/redesign/FormButton';
import RHFInputBox from './RHFInputBox';
import RHFToggle from './RHFToggle';
// import actions from 'src/actions';
// import Dialog from 'src/components/common/Dialog.redesign';

interface IRHFLeaseClauseProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    name: string;
    label: string;
    showDescription?: boolean;
    descriptionRequired?: boolean;
    inputStyle?: React.CSSProperties;
    toggleStyle?: React.CSSProperties;
}

const RHFLeaseClause = (props: IRHFLeaseClauseProps) => {
    // const dispatch = useDispatch();

    const onToggleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // dispatch(() => actions.layout.showDialog(`${DialogList.CLAUSE_DESCRIPTION}${props.name}`));
        console.log('show dialog now');
    };

    return (
        <div style={{ marginRight: '1rem' }}>
            <div>
                <RHFToggle
                    name={props.name}
                    label={props.label}
                    register={props.register}
                    errors={props.errors}
                    onChange={onToggleChange}
                    bodyStyle={props?.toggleStyle}
                />
            </div>
            {props.descriptionRequired === true && (
                <div>
                    <RHFInputBox
                        label="Description"
                        name={`${props.name}Description`}
                        register={props.register}
                        errors={props.errors}
                        className="description"
                        bodyStyle={props?.inputStyle}
                    />
                </div>
            )}
            {/* stuff 
            <Dialog title="Clause Description" dialogName={`${DialogList.CLAUSE_DESCRIPTION + props.name}`} onCloseDialog={() => dispatch(actions.layout.hideDialog)}>
                <div>

                    <RHFInputBox
                        name={`${props.name}Description`}
                        label="Clause Description"
                        register={props.register}
                        errors={props.errors}
                    />

                     <Button text="SUBMIT" size="small" onClick={dispatch(actions.layout.hideDialog)} intent="primary" />
                </div>
            </Dialog>
            */}
        </div>
    );
};

export default RHFLeaseClause;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFLeaseClause.tsx